import { RenderProps, useToast } from '@chakra-ui/react'
import { analytics } from 'analytics'
import { useMemo } from 'react'

import { CustomToast } from 'components/common/Toast/CustomToast'
import {
  VIEW_ONLY_TOAST_MESSAGE,
  VIEW_ONLY_TOAST_TITLE,
} from 'constants/error.constants'
import { VIEW_ONLY_TOAST_TRIGGERED } from 'constants/track.constants'

export function useCustomToast() {
  const toast = useToast()
  const duration = 10000
  const customToast = useMemo(
    () => ({
      showErrorToast: function (title: string, description?: string) {
        toast({
          position: 'bottom-right',
          status: 'error',
          duration,
          render: (props: RenderProps) =>
            CustomToast({
              id: props.id,
              onClose: props.onClose,
              title,
              description,
              type: 'Error',
            }),
        })
      },

      showSuccessToast: function (title: string, description?: string) {
        toast({
          position: 'bottom-right',
          status: 'success',
          duration,
          render: (props: RenderProps) =>
            CustomToast({
              id: props.id,
              onClose: props.onClose,
              title,
              description,
              type: 'Success',
            }),
        })
      },
      showInfoToast: function (title: string, description?: string) {
        toast({
          position: 'bottom-right',
          status: 'info',
          duration,
          render: (props: RenderProps) =>
            CustomToast({
              id: props.id,
              onClose: props.onClose,
              title,
              description,
              type: 'Info',
            }),
        })
      },
      showDefaultToast: function (title: string, description?: string) {
        toast({
          position: 'bottom-right',
          duration,
          render: (props: RenderProps) =>
            CustomToast({
              id: props.id,
              onClose: props.onClose,
              title,
              description,
              type: 'Default',
            }),
        })
      },
      showWarningToast: function (title: string, description?: string) {
        toast({
          position: 'bottom-right',
          duration,
          render: (props: RenderProps) =>
            CustomToast({
              id: props.id,
              onClose: props.onClose,
              title,
              description,
              type: 'Warning',
            }),
        })
      },
      showViewOnlyDefaultToast: function () {
        analytics.track(VIEW_ONLY_TOAST_TRIGGERED)

        toast({
          position: 'bottom-right',
          duration,
          render: (props: RenderProps) =>
            CustomToast({
              id: props.id,
              onClose: props.onClose,
              title: VIEW_ONLY_TOAST_TITLE,
              description: VIEW_ONLY_TOAST_MESSAGE,
              type: 'Default',
            }),
        })
      },
    }),
    [toast]
  )

  return customToast
}
